/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createSin } from '../../factoriesAny.js';
export var sinDependencies = {
  typedDependencies: typedDependencies,
  createSin: createSin
};